// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"styles_videoWrapper__RK0U5","videoOverlay":"styles_videoOverlay__12SNV","playButton":"styles_playButton__trWCS"};